/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Authorization_LabelInputs */

const en_claims_authorization_label = /** @type {(inputs: Claims_Authorization_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please read carefully the statement on authorization and certify that the claim is accurate.`)
};

const fr_claims_authorization_label = /** @type {(inputs: Claims_Authorization_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez lire attentivement la déclaration d'autorisation et certifier que la réclamation est exacte.`)
};

/**
* | output |
* | --- |
* | "Please read carefully the statement on authorization and certify that the claim is accurate." |
*
* @param {Claims_Authorization_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_authorization_label = /** @type {((inputs?: Claims_Authorization_LabelInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Authorization_LabelInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_authorization_label(inputs)
	return fr_claims_authorization_label(inputs)
});